import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=56fa2ce4&scoped=true&lang=pug&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=56fa2ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa2ce4",
  null
  
)

export default component.exports